import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Container } from '@mui/material';
// components
import Logo from '../components/logo';
// sections
import { LoginForm } from '../sections/auth/login';
import Illustration from '../components/logo/Illustration.png'

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 400,
  // margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  background: 'white',
  borderRadius: '10px',
  // padding: theme.spacing(5, 5),
}));

const MainContent = styled('div')(() => ({
  // backgroundImage: `url(https://www.paxes.com/blog/wp-content/uploads/2023/01/employee-self-service-portal.jpg)`,
  backgroundColor: "white",
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'local',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  width: '100%',
  display: 'flex',
  height: '100vh',
  justifyContent: 'flex-end',
  alignItems: 'center',
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> Login </title>
      </Helmet>

      <StyledRoot>
        <MainContent>
          {/* <Logo
            sx={{
              position: 'fixed',
              top: { xs: 16, sm: 24, md: 40 },
              left: { xs: 16, sm: 24, md: 40 },
            }}
          /> */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: "0 auto"
            }}
          >
            <img src={Illustration} alt="Centered Image" style={{ maxWidth: '75%', borderRadius: '10px', margin: "auto" }} />
          </Box>

          <Container id="login-container" maxWidth="sm" sx={{ margin: "inherit" }}>
            <StyledContent>
              <LoginForm />
            </StyledContent>
          </Container>
        </MainContent>
      </StyledRoot>
    </>
  );
}
